module.exports = __webpack_public_path__ + "img/login-page-logo-dark.bcdf900f.svg";